var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('DefaBaseButton',{attrs:{"loading":_vm.submitting,"disabled":_vm.submitting}},[_vm._v(" "+_vm._s(_vm.$t("orderSubmission.submit"))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }